import React from "react";
import Meta from "../components/Meta";
import HeaderSection from "../components/header/HeaderSection";

const Page = () => {

  return (
    <>
      <Meta title="Engineering Books - The bookshelf of most suggested and recommended engineering books"/>
      <HeaderSection
        title="Community Guidelines"
        subtitle="These are our rules and guidelines for participating in our community"
      />

      <section className="relative py-1 md:py-24">
        <div className="container">
          <div className="mx-auto max-w-[48.125rem]">
            <h2 className="text-jacarta-700 font-display text-l dark:text-white">Introduction</h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              Everything you need to get started on the Engineering Book Club.
            </p>
            <h2 className="text-jacarta-700 font-display text-l dark:text-white">Read our Code Of Conduct</h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              Accept the terms and conditions proposed there. This is the most important thing for being part of our community.
            </p>
            <h2 className="text-jacarta-700 font-display text-l dark:text-white">
              Get familiar with the platform
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              Navigate through the main menu and discover how the information is organized. You will find the following sections:
            </p>
            <h2 className="text-jacarta-700 font-display text-l dark:text-white">
              The Club
            </h2>
            <h2 className="text-jacarta-700 font-display text-l dark:text-white">
              Announcements:
            </h2>
            <h2 className="text-jacarta-700 font-display text-l dark:text-white">
              Say Hello:
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              Introduce yourself to the community and discover the talented people who are already in the club.
            </p>
            <h2 className="text-jacarta-700 font-display text-l dark:text-white">
              General discussions:
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              We post topics or articles weekly to debate and learn from.
            </p>
            <h2 className="text-jacarta-700 font-display text-l dark:text-white">
              Community Online events:
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              This is where the magic happens, and we all go together for a coffee chat on a Zoom call to discuss and debate about books and other topics.
            </p>
            <h2 className="text-jacarta-700 font-display text-l dark:text-white">
              Book Proposals:
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              The place where you can suggest books to read. If you liked it or because you want to find people who want to read it with you.
            </p>
            <h2 className="text-jacarta-700 font-display text-l dark:text-white">
              Books:
            </h2>
            <p className="dark:text-jacarta-60 mb-5 leading-normal">
              This is where you will find the bookshelf with all the books that we have read together.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Page;
